import { POWERUP_TYPES, POWERUP_FALL_SPEED } from '../config/constants.js';

export class Powerup {
  constructor(x, y, type) {
    this.x = x;
    this.y = y;
    this.type = type;

    // Varying sizes for coffee beans (small to large)
    if (type === POWERUP_TYPES.BEAN) {
      const sizeVariation = 0.7 + Math.random() * 0.3; // 0.7 to 1.0 multiplier (reduced max size)
      this.width = 20 * sizeVariation; // Reduced from 24
      this.height = 20 * sizeVariation;
    } else {
      this.width = 20; // Reduced from 24
      this.height = 20;
    }

    this.vy = POWERUP_FALL_SPEED;
    this.createdAt = Date.now(); // For pulsing animation

    // Rotation and drift for animations
    this.rotation = 0; // For swirling beans
    this.driftX = 0; // For zig-zagging hearts
    this.driftPhase = Math.random() * Math.PI * 2; // Random starting phase for variety

    // Load sprite image
    this.image = new Image();
    this.image.src = this.getImageUrl();
  }

  getImageUrl() {
    switch (this.type) {
      case POWERUP_TYPES.BEAN:
        return 'https://cdn.prod.website-files.com/687d960560ee14f74b3f0f52/692ab185728dea0662ee768a_bean_mid.png';
      case POWERUP_TYPES.GOLD_BEAN:
        // Use same bean image but with golden glow (rendered differently)
        return 'https://cdn.prod.website-files.com/687d960560ee14f74b3f0f52/692ab185728dea0662ee768a_bean_mid.png';
      case POWERUP_TYPES.HEART:
        return 'https://cdn.prod.website-files.com/687d960560ee14f74b3f0f52/692ebfd281116d8cba4c4514_heart.png';
      case POWERUP_TYPES.SPECIAL:
        return 'https://cdn.prod.website-files.com/687d960560ee14f74b3f0f52/692ec08dd1093ab75a5f61b2_powerup.png';
      default:
        return 'https://cdn.prod.website-files.com/687d960560ee14f74b3f0f52/692ab185728dea0662ee768a_bean_mid.png';
    }
  }

  update(deltaTime = 16.67) {
    // Powerups fall at a constant speed, using moveScale similar to player
    const moveScale = 0.0015;
    this.y += this.vy * moveScale * deltaTime;

    // Coffee beans and gold beans: swirl/spin as they fall
    if (this.type === POWERUP_TYPES.BEAN || this.type === POWERUP_TYPES.GOLD_BEAN) {
      this.rotation += 0.08 * (deltaTime / 16.67); // Spin rotation
      // Slight horizontal wobble
      this.driftPhase += 0.05 * (deltaTime / 16.67);
      this.driftX = Math.sin(this.driftPhase) * 15;
    }

    // Hearts: zig-zag drift as they fall
    if (this.type === POWERUP_TYPES.HEART) {
      this.driftPhase += 0.04 * (deltaTime / 16.67); // Slower phase for gentler drift
      this.driftX = Math.sin(this.driftPhase) * 20; // Wider zig-zag amplitude
    }
  }

  isOffScreen(canvasHeight) {
    return this.y > canvasHeight + 20;
  }

  render(ctx) {
    ctx.save();

    // Apply horizontal drift for both beans and hearts
    const renderX = this.x + this.driftX;

    // Pulsing animation for hearts
    if (this.type === POWERUP_TYPES.HEART) {
      const time = Date.now() - this.createdAt;
      const pulse = Math.sin(time / 200) * 0.15 + 1; // Oscillates between 0.85 and 1.15
      const scale = pulse;

      // Translate to center, scale, translate back
      ctx.translate(renderX, this.y);
      ctx.scale(scale, scale);
      ctx.translate(-renderX, -this.y);

      // Subtle glow effect
      ctx.shadowColor = '#ff6b9d';
      ctx.shadowBlur = 8 * pulse; // Pulsing glow
    }

    // Pulsing animation and rotation for coffee beans
    if (this.type === POWERUP_TYPES.BEAN) {
      const time = Date.now() - this.createdAt;
      const pulse = Math.sin(time / 300) * 0.12 + 1; // Slightly slower, oscillates between 0.88 and 1.12
      const scale = pulse;

      // Translate to center, rotate, scale, translate back
      ctx.translate(renderX, this.y);
      ctx.rotate(this.rotation);
      ctx.scale(scale, scale);
      ctx.translate(-renderX, -this.y);

      // Subtle golden glow effect
      ctx.shadowColor = '#ffb84d';
      ctx.shadowBlur = 6 * pulse; // Pulsing glow
    }

    // Enhanced golden glow for gold beans (instant special)
    if (this.type === POWERUP_TYPES.GOLD_BEAN) {
      const time = Date.now() - this.createdAt;
      const pulse = Math.sin(time / 200) * 0.2 + 1; // Faster, stronger pulse (0.8 to 1.2)
      const scale = pulse;

      // Translate to center, rotate, scale, translate back
      ctx.translate(renderX, this.y);
      ctx.rotate(this.rotation);
      ctx.scale(scale, scale);
      ctx.translate(-renderX, -this.y);

      // Strong golden glow effect with pulsing intensity
      ctx.shadowColor = '#ffd700';
      ctx.shadowBlur = 15 * pulse; // Much stronger pulsing glow

      // Add a golden tint overlay
      ctx.globalAlpha = 0.3 + (pulse - 1) * 0.3; // Varying golden tint
      ctx.fillStyle = '#ffd700';
    }

    // Draw sprite image with pixelated rendering
    if (this.image.complete) {
      ctx.imageSmoothingEnabled = false;
      ctx.drawImage(
        this.image,
        renderX - this.width / 2,
        this.y - this.height / 2,
        this.width,
        this.height
      );
    }

    ctx.restore();
  }
}
